import { createContext } from "react";

export const HighlightCreationContext = createContext();
